import { Loading, Message } from 'element-ui';
import router from './../../router/index'
import lodash from 'lodash'
if (!process.env.NODE_ENV) {
  process.env.NODE_ENV = 'development'
}
let RequestUrl = 'https://gdxadmin-core.zhongkg.com'
// let RequestUrl = 'http://luluwenwen.natapp1.cc'
// let RequestUrl = 'http://liang666.natapp1.cc'


if (process.env.NODE_ENV == 'development') {
  // console.log(window.location.hash,'window.location.hash')
  // console.log(window.location,'window.location.hash')
  // if(window.location){
  //   if (window.location.href=='http://192.168.2.42:8080/login') {
  //     window.location.href='http://192.168.2.42:8080/login#apiHref=http://192.168.2.19:9006'
  //     window.sessionStorage.setItem('apiHref','http://192.168.2.19:9006')
  //   }
  //   // else{
  //   //   // window.location.href='http://d.wentuguoji.cn/login'
  //   //   window.sessionStorage.setItem('apiHref','')
  //   // }
  // }
  if (window && window.location && window.location.hash && window.location.hash.indexOf('#') != -1) {
    let hash =window.location.hash.substring(1)
    // console.log(hash,'hash')
    let pairs = hash.split('&')
    if (pairs && pairs.length) {
      let reject = lodash.reject(pairs, (val) => val.indexOf('apiHref') == -1)
      if (reject && reject.length) {
        let rejectObj = reject[0].split('=')
        if (rejectObj && rejectObj.length && rejectObj[1]) {
          RequestUrl = rejectObj[1]
        }
      }
    }
    // this.$route.hash({path:window.location.hash})
    console.log( RequestUrl, window.sessionStorage,' RequestUrl');
    window.sessionStorage.setItem('apiHref', RequestUrl)
    // this.sessionStorage.setItem('apiHref', RequestUrl)
  } else if (window.sessionStorage.getItem('apiHref')) {
    RequestUrl = window.sessionStorage.getItem('apiHref')
  }
}
export default {
  request: function (opt) {

    // let loadingInstance = Loading.service()
    if (typeof opt == 'undefined') {
      // loadingInstance.close();
      return;
    }

    // if (typeof (opt.timeout) == 'undefined') {
    //   opt.timeout = 1000;
    //   console.log(1111);
    // }

    if (typeof opt.cache == 'undefined') {
      opt.cache = false;
    }
    //opt = $.extend(opt, p);
    if (typeof (opt.type) == 'undefined') {
      opt.type = 'GET'
    }
    if (typeof (opt.async) == 'undefined') {
      opt.async = false;
    }
    if (typeof (opt.dataType) == 'undefined') {
      opt.dataType = 'json'
    }
    if (typeof (opt.contentType) == 'undefined') {
      opt.contentType = 'application/x-www-form-urlencoded;chartset=UTF-8'
    }
    if (typeof (opt.params) == 'undefined' || opt.params == null) {
      opt.params = {};
    }
    // opt.params.date = new Date();
    if (typeof (opt.beforeSubmit) != 'undefined') {
      var flag = opt.beforeSubmit(opt);
      if (!flag) {
        // loadingInstance.close();
        return;
      }
    }
    if (typeof (opt.resultMsg) == 'undefined') {
      opt.resultMsg = true;
    }
    opt.token = ''
    if (localStorage.getItem('aljsToken') && localStorage.getItem('aljsToken') != '') {
      opt.token = localStorage.getItem('aljsToken')
    } else {
      if (opt.url.indexOf('/sys/login') == -1) {
        Message({
          message: '登录过期，请重新登录！',
          duration: 3000,
          type: 'warning'
        })
        localStorage.clear()
        sessionStorage.clear()
        let keys = document.cookie.match(/[^=;]+(?=\=)/g)
        if (keys) {
          for (let i = keys.length; i--;) {
            document.cookie = keys[i] + '=0;expires=' + new Date(0).toUTCString()
          }
        }
        router.replace({
          path: '/login'
        })
      }
    }
    if (opt.url.indexOf('http') == -1) {
      opt.url = RequestUrl + opt.url
    }
    $.ajax({
      async: opt.async,
      url: opt.url,
      dataType: opt.dataType,
      contentType: opt.contentType,
      data: opt.params,
      crossDomain: opt.crossDomain || false,
      type: opt.type,
      cache: opt.cache,
      processData:opt.processData,
      headers: {
        token: opt.token,
      },

      success: function (data) {
        // console.log(opt)
        //关闭遮罩
        // dialogLoading(false);
        // loadingInstance.close();
        if (typeof data == 'string' && data.indexOf("exception") > 0 || typeof data.code != 'undefined' && data.code != '200') {
          var result = { code: null };
          if (typeof data == 'string') {
            result = eval('(' + data + ')')
          } else if (typeof data == 'object') {
            result = data;
          }
          if (opt.resultMsg && result.message) {
            // layer.alert(result.message, {icon: 5});
            Message({
              message: result.message,
              duration: 5000,
              type: 'warning'
            })
            if (result.code === 400) {
              opt.successCallback(data);
            }
            if (result.code === 401) {
              localStorage.clear()
              sessionStorage.clear()
              let keys = document.cookie.match(/[^=;]+(?=\=)/g)
              if (keys) {
                for (let i = keys.length; i--;) {
                  document.cookie = keys[i] + '=0;expires=' + new Date(0).toUTCString()
                }
              }
              router.replace({
                path: '/login'
              })
            }
          }
          return;
        }
        if (opt.resultMsg && data.msg) {
          Message({
            message: data.msg,
            duration: 5000,
            type: 'warning'
          })
          if (result.code === 401) {
              localStorage.clear()
              sessionStorage.clear()
              let keys = document.cookie.match(/[^=;]+(?=\=)/g)
              if (keys) {
                for (let i = keys.length; i--;) {
                  document.cookie = keys[i] + '=0;expires=' + new Date(0).toUTCString()
                }
              }
              router.replace({
                path: '/login'
              })
            }
          return;
        }
        if (data.code === 401) {
          Message({
            message: '登录信息已过期，请重新登录！',
            duration: 5000,
            type: 'warning'
          })
          localStorage.clear()
          sessionStorage.clear()
          let keys = document.cookie.match(/[^=;]+(?=\=)/g)
          if (keys) {
            for (let i = keys.length; i--;) {
              document.cookie = keys[i] + '=0;expires=' + new Date(0).toUTCString()
            }
          }
          router.replace({
            path: '/login'
          })
        }
        if (typeof (opt.successCallback) != 'undefined'&&data.code==200) {
          opt.successCallback(data);
        }
      },
      error: function (err) {
        Message({
          message: err.responseJSON.message,
          duration: 5000,
          type: 'warning'
        })
        // loadingInstance.close();
        //关闭遮罩
        // dialogLoading(false);

        // layer.alert("此页面发生未知异常,请联系管理员", {icon: 5});
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/ajax.js